import { HeaderProvider } from 'header'
import { Seo } from 'ui-components'
import StateProvider from '~map-search/states/provider'
import { Main } from './Main'

const App = (props) => {
  const { userGeolocation } = props

  return (
    <HeaderProvider>
      <StateProvider
        initialState={{
          userGeolocation
        }}
      >
        <Seo />
        <Main />
      </StateProvider>
    </HeaderProvider>
  )
}

export { App }
export default App
